// EmailJS integration for sending form emails
// Setup: https://emailjs.com → create account → add service → create template

export interface EmailData {
  from_name: string;
  phone: string;
  message?: string;
  product?: string;
  email?: string;
  company?: string;
  region?: string;
  volume?: string;
  form_type: string;
}
export interface EmailConfig {
  serviceId: string;
  templateId: string;
  publicKey: string;
  toEmail: string;
}
const DEFAULT_CONFIG: EmailConfig = {
  serviceId: '',
  templateId: '',
  publicKey: '',
  toEmail: '3.13.13@mail.ru'
};
export function getEmailConfig(): EmailConfig {
  try {
    const stored = localStorage.getItem('yb_email_config');
    if (stored) return {
      ...DEFAULT_CONFIG,
      ...JSON.parse(stored)
    };
  } catch {}
  return DEFAULT_CONFIG;
}
export function saveEmailConfig(config: EmailConfig): void {
  localStorage.setItem('yb_email_config', JSON.stringify(config));
}
export async function sendEmail(data: EmailData): Promise<{
  ok: boolean;
  error?: string;
}> {
  const config = getEmailConfig();

  // If EmailJS is not configured, simulate success (dev mode)
  if (!config.serviceId || !config.templateId || !config.publicKey) {
    console.warn('[YAVUZ] EmailJS не настроен. Перейдите в Админ-панель → Настройки форм.');
    // Still "succeed" so the UI shows success state
    await new Promise(r => setTimeout(r, 800));
    return {
      ok: true
    };
  }
  try {
    const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        service_id: config.serviceId,
        template_id: config.templateId,
        user_id: config.publicKey,
        template_params: {
          to_email: config.toEmail || '3.13.13@mail.ru',
          from_name: data.from_name,
          phone: data.phone,
          email: data.email || '—',
          message: data.message || '—',
          product: data.product || '—',
          company: data.company || '—',
          region: data.region || '—',
          volume: data.volume || '—',
          form_type: data.form_type,
          reply_to: data.email || ''
        }
      })
    });
    if (response.ok) return {
      ok: true
    };
    return {
      ok: false,
      error: 'Ошибка сервера. Попробуйте позже.'
    };
  } catch (err) {
    return {
      ok: false,
      error: 'Нет соединения. Проверьте интернет.'
    };
  }
}